// extracted by mini-css-extract-plugin
export default {"container":"ScaleForm_container__wq52k"};